import request from "superagent";
import Auth from "../../routes/Auth";

const API = process.env.REACT_APP_API_URL;

// FE-side aliases so instructors can use natural-language header
// names in the CSV. The BE only recognizes the canonical form on the
// right (email / team / team_id); anything else gets rewritten
// in-place before POST.
const HEADER_ALIASES = {
  email: "email",
  emailaddress: "email",
  username: "email",
  team: "team",
  teamname: "team",
  teamid: "team_id",
  team_id: "team_id",
};

const normalizeHeader = (h) => (h || "")
  .toLowerCase()
  .replace(/\(.*?\)/g, "")
  .replace(/[^a-z0-9]+/g, "")
  .trim();

const readFileAsText = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result || "");
  reader.onerror = () => reject(new Error("Could not read the uploaded file."));
  reader.readAsText(file);
});

// Starter template offered on the Reassign Teams step. Two lines
// because downstream CSV parsers on Windows sometimes reject files
// without a trailing newline after the last data row.
export const REASSIGN_TEMPLATE_CSV =
  "email,team\nexample@student.edu,Team Alpha\n";

export const runReassignUpload = async ({ file, gameId, onProgress }) => {
  const report = (stage, extra) => {
    if (onProgress) onProgress({ stage, ...(extra || {}) });
  };

  report("parsing");
  const text = await readFileAsText(file);
  const raw = String(text).replace(/^﻿/, "").split(/\r?\n/);
  const nonEmptyLines = raw.filter(l => l && l.trim().length > 0);

  if (nonEmptyLines.length === 0) {
    const err = new Error("CSV is empty.");
    err.kind = "validation";
    err.errors = ["The uploaded file is empty."];
    throw err;
  }
  if (nonEmptyLines.length < 2) {
    const err = new Error("CSV has no data rows.");
    err.kind = "validation";
    err.errors = ["The uploaded file has no data rows below the header."];
    throw err;
  }

  const headerLine = nonEmptyLines[0];
  const rawHeaders = headerLine.split(",").map(s => s.trim());
  const canonical = rawHeaders.map(h => HEADER_ALIASES[normalizeHeader(h)] || h);

  if (!canonical.includes("email")) {
    const err = new Error("Missing email column.");
    err.kind = "validation";
    err.errors = ['CSV must include an "email" column.'];
    throw err;
  }
  if (!canonical.includes("team") && !canonical.includes("team_id")) {
    const err = new Error("Missing team column.");
    err.kind = "validation";
    err.errors = ['CSV must include a "team" or "team_id" column.'];
    throw err;
  }

  const rewrittenHeader = canonical.join(",");
  const dataRows = nonEmptyLines.slice(1);
  const csv = [rewrittenHeader, ...dataRows].join("\n") + "\n";

  report("uploading");
  const token = Auth.getToken();
  const req = request
    .post(`${API}v2/games/bulk-assign/`)
    .set("Accept", "application/json")
    .attach("file", new Blob([csv], { type: "text/csv" }), "reassign.csv")
    .field("game_id", String(gameId));
  if (token) req.set("Authorization", `Token ${token}`);

  const res = await req;
  const body = (res && res.body) || {};
  report("success", body);
  return body;
};



// WEBPACK FOOTER //
// ./src/instructor/utils/reassign-upload.js